/* eslint-disable */
/*eslint-disable*/
import React, { useState, useEffect, useContext, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { FirebaseContext } from "common";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  MenuItem,
  FormControl,
  Select,
  InputLabel,
  FormHelperText,
  CircularProgress,
  Checkbox,
  FormControlLabel
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  AddUserTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#009ad8",
    color: "#fff",
    padding: "16px",
    borderRadius: "4px 4px 0 0",
    fontSize: "18px",
    fontWeight: "bold"
  },
  selectField: {
    backgroundColor: "#ffffff",
    borderRadius: "4px",
    border: "1px solid #ccc",
    padding: "10px 12px",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#ccc"
      },
      "&:hover fieldset": {
        borderColor: "#999"
      },
      "&.Mui-focused fieldset": {
        borderColor: "#009ad8"
      }
    }
  },
  userTypeField: {
    backgroundColor: "#ffffff",
    borderRadius: "4px",
    border: "1px solid #ccc",
    padding: "10px 12px",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#ccc"
      },
      "&:hover fieldset": {
        borderColor: "#999"
      },
      "&.Mui-focused fieldset": {
        borderColor: "#009ad8"
      }
    }
  },
  saveButton: {
    fontWeight: "bold",
    color: "#ffffff",
    backgroundColor: "#009ad8",
    "&:hover": {
      backgroundColor: "#2c6e31"
    }
  },
  closeButton: {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    textTransform: "none",
    "&:disabled": {
      backgroundColor: "#cccccc",
      color: "#666666"
    }
  },
  dialogContent: {
    backgroundColor: "#fafafa",
    padding: "20px"
  },
  formControl: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(1)
  },
  textField: {
    backgroundColor: "#ffffff",
    borderRadius: "4px",
    "& .MuiInputBase-input": {
      padding: "12px"
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#ccc"
      },
      "&:hover fieldset": {
        borderColor: "#999"
      },
      "&.Mui-focused fieldset": {
        borderColor: "#009ad8"
      }
    }
  },
  dialogActions: {
    padding: "16px",
    justifyContent: "space-between"
  },
  label: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#333",
    marginBottom: "6px",
    display: "block",
    transition: "0.2s ease all"
  },
  floatingLabel: {
    transform: "translate(14px, -12px) scale(0.75)",
    backgroundColor: "#ffffff",
    padding: "0 4px",
    color: "#009ad8"
  },
  formHelperText: {
    fontSize: "12px",
    color: "#d32f2f"
  },
  input: {
    fontSize: "14px",
    padding: "10px 12px"
  },
  inputField: {
    marginBottom: theme.spacing(1.5)
  },
  checkboxContainer: {
    display: "flex",
    alignItems: "center",
    padding: "8px 12px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    backgroundColor: "#ffffff",
    marginBottom: "8px",
    "&:hover": {
      borderColor: "#999",
    },
    "&.Mui-focused": {
      borderColor: "#009ad8",
    },
  },
  checkboxLabel: {
    marginLeft: "8px",
    fontSize: "14px",
    fontWeight: "600",
    color: "#333",
  }
}));

const FormComponentManageAdmins = ({
  data = {},
  columns = [],
  modalType,
  onClose,
  onSubmit
}) => {
  const { api } = useContext(FirebaseContext);
  const { fetchAllBranches } = api;

  const classes = useStyles();
  const branchManagementReducer = useSelector((state) => state.branchData);
  const usertypesreducer = useSelector((state) => state.usertypes);
  console.log("Columns:", columns);

  const flattenColumns = (cols) => {
    const flat = [];
    cols.forEach((col) => {
      if (col.id === "TenantDetails") {
        const filteredColumns = col.columns.filter(
          (column) =>
            column.accessorKey !== "userType" &&
            column.accessorKey !== "referralId" &&
            column.accessorKey !== "createdAt"
        );
        flat.push(...filteredColumns);
      } else if (col.columns) {
        flat.push(...flattenColumns(col.columns));
      } else {
        flat.push(col);
      }
    });
    return flat;
  };

  const flattenedColumns = flattenColumns(columns);

  const getNestedValue = (obj, path) => {
    if (!path || path === undefined) {
      console.log("Path undefined");
      return "";
    }
    
    return path.split(".").reduce((acc, key) => {
      if (acc === null || acc === undefined) return "";
      return acc[key];
    }, obj);
  };

  const setNestedValue = (obj, path, value) => {
    if (!path) return;
    
    const keys = path.split(".");
    const lastKey = keys.pop();
    const nestedObj = keys.reduce((acc, key) => {
      if (!acc[key]) acc[key] = {};
      return acc[key];
    }, obj);
    nestedObj[lastKey] = value;
  };

  const initialFields = flattenedColumns
    .filter(
      (field) =>
        !field.enableHiding &&
        field.accessorKey &&
        field.accessorKey.toLowerCase() !== "username" &&
        field.accessorKey.toLowerCase() !== "id"
    )
    .map((field) => ({
      ...field,
      value:
        modalType === "edit"
          ? getNestedValue(data, field.accessorKey) || ""
          : field.accessorKey === "isSuperAdmin" ? false : "",
      isEditable: field.enableEditing !== false
    }));

  const [fields, setFields] = useState(initialFields);
  const [errors, setErrors] = useState({});
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    console.log("Current fields state:", fields);
  }, [fields]);

  const handleInputChange = (accessorKey, value) => {
    setFields((prevFields) =>
      prevFields.map((field) =>
        field.accessorKey === accessorKey ? { ...field, value } : field
      )
    );
  };

  const validateForm = () => {
    const newErrors = {};

    fields.forEach((field) => {
      if (field.required && !field.value) {
        newErrors[field.accessorKey] = `${field.header} is required`;
      }

      if (field.accessorKey === "password" && field.value) {
        if (field.value.length < 6) {
          newErrors[field.accessorKey] =
            "Password must be at least 6 characters long";
        }
      }

      if (field.accessorKey === "mobile" && field.value) {
        const phoneRegex = /^\+?[1-9]\d{1,14}$/;
        if (!phoneRegex.test(field.value)) {
          newErrors[field.accessorKey] =
            "Please enter a valid phone number in international format (e.g., +1234567890)";
        }
      }

      if (field.accessorKey === "email" && field.value) {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(field.value)) {
          newErrors[field.accessorKey] = "Please enter a valid email address";
        }
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validateForm()) return;

    setLoading(true);

    const updatedData = { ...data };

    console.log("🚀 Initial `updatedData` before modifications:", updatedData);

    fields.forEach((field) => {
      if (field.isEditable && field.accessorKey) {
        setNestedValue(updatedData, field.accessorKey, field.value);
      }
    });

    console.log("✅ Final `updatedData` after modifications:", updatedData);

    onSubmit(updatedData);
    setLoading(false);
    onClose();
  };

  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle className={classes.AddUserTitle}>
        {modalType === "edit" ? "Edit User" : "Add User"}
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        {fields.map((field) => (
          <FormControl
            key={field.accessorKey}
            className={classes.formControl}
            error={Boolean(errors[field.accessorKey])}
            fullWidth
          >
            {field.accessorKey === "userType" ? (
              <>
                <InputLabel className={classes.label}>
                  {field.header}
                </InputLabel>
                <Select
                  value={field.value}
                  onChange={(e) =>
                    handleInputChange(field.accessorKey, e.target.value)
                  }
                  disabled={!field.isEditable}
                  className={classes.inputField}
                >
                  {usertypesreducer?.usertypes &&
                    Object.keys(usertypesreducer.usertypes).map((key) => (
                      <MenuItem
                        key={key}
                        value={usertypesreducer.usertypes[key]}
                      >
                        {usertypesreducer.usertypes[key]}
                      </MenuItem>
                    ))}
                </Select>
                {errors[field.accessorKey] && (
                  <FormHelperText className={classes.formHelperText}>
                    {errors[field.accessorKey]}
                  </FormHelperText>
                )}
              </>
            ) : field.accessorKey === "manager" ? (
              <>
                <InputLabel className={classes.label}>
                  {field.header}
                </InputLabel>
                <Select
                  value={field.value}
                  onChange={(e) =>
                    handleInputChange(field.accessorKey, e.target.value)
                  }
                  disabled={!field.isEditable}
                  className={classes.inputField}
                >
                  {branchManagementReducer.branches.map((branch) => (
                    <MenuItem key={branch.branchId} value={branch.BranchName}>
                      {branch.BranchName}
                    </MenuItem>
                  ))}
                </Select>
                {errors[field.accessorKey] && (
                  <FormHelperText className={classes.formHelperText}>
                    {errors[field.accessorKey]}
                  </FormHelperText>
                )}
              </>
            ) : field.type === "select" ? (
              <>
                <InputLabel className={classes.label}>
                  {field.header}
                </InputLabel>
                <Select
                  value={field.value}
                  onChange={(e) =>
                    handleInputChange(field.accessorKey, e.target.value)
                  }
                  disabled={!field.isEditable}
                  className={classes.inputField}
                >
                  {field.options?.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
                {errors[field.accessorKey] && (
                  <FormHelperText className={classes.formHelperText}>
                    {errors[field.accessorKey]}
                  </FormHelperText>
                )}
              </>
            ) : field.accessorKey === "isSuperAdmin" ? (
              <div className={classes.checkboxContainer}>
                <Checkbox
                  checked={Boolean(field.value)}
                  onChange={(e) =>
                    handleInputChange(field.accessorKey, e.target.checked)
                  }
                  disabled={!field.isEditable}
                  color="primary"
                />
                <span className={classes.checkboxLabel}>
                  {field.header}
                </span>
                {errors[field.accessorKey] && (
                  <FormHelperText className={classes.formHelperText}>
                    {errors[field.accessorKey]}
                  </FormHelperText>
                )}
              </div>
            ) : field.accessorKey === "adminHomeOffice" ? (
              <>
                <InputLabel className={classes.label}>
                  {field.header}
                </InputLabel>
                <Select
                  value={field.value}
                  onChange={(e) =>
                    handleInputChange(field.accessorKey, e.target.value)
                  }
                  disabled={!field.isEditable}
                  className={classes.inputField}
                >
                  {branchManagementReducer.branches.map((branch) => (
                    <MenuItem key={branch.BranchName} value={branch.BranchName}>
                      {branch.BranchName}
                    </MenuItem>
                  ))}
                </Select>
                {errors[field.accessorKey] && (
                  <FormHelperText className={classes.formHelperText}>
                    {errors[field.accessorKey]}
                  </FormHelperText>
                )}
              </>
            ) : (
              <TextField
                label={field.header}
                type={field.type || "text"}
                value={field.value}
                disabled={!field.isEditable}
                onChange={(e) =>
                  handleInputChange(field.accessorKey, e.target.value)
                }
                variant="outlined"
                className={classes.textField}
                error={Boolean(errors[field.accessorKey])}
                helperText={errors[field.accessorKey]}
                fullWidth
                InputProps={{
                  className: classes.input
                }}
              />
            )}
          </FormControl>
        ))}
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button
          onClick={onClose}
          className={classes.closeButton}
          disabled={isLoading}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          className={classes.saveButton}
          disabled={isLoading}
        >
          {isLoading ? <CircularProgress size={20} /> : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

FormComponentManageAdmins.propTypes = {
  data: PropTypes.object,
  columns: PropTypes.array.isRequired,
  modalType: PropTypes.oneOf(["add", "edit"]).isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default FormComponentManageAdmins;